const baseUrl = process.env.APP_BASEURL;

export const surveyApi = {
  saveDiagnosis: baseUrl + '/survey/save_diagnosis',
  saveLegal: baseUrl + '/survey/save_legal',
  save: baseUrl + '/survey/save',
  getConfigInfo: baseUrl + '/config/system',
};
